
import moment from 'moment';
import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
import PageHeader from '@/components/PageHeader.vue';
import DataTableHeader from '@/components/DataTableHeader.vue';
import OperationLead from '@/components/OperationLead.vue';
import OperationTags from '@/components/OperationTags.vue';
import OperationPayments from '@/components/OperationPayments.vue';
import OperationFinalPaymentDate from '@/components/OperationFinalPaymentDate.vue';
import OperationCustomer from '@/components/OperationCustomer.vue';
import OperationProvince from '@/components/OperationProvince.vue';
import OperationUnifiedDates from '@/components/OperationUnifiedDates.vue';
import OperationSupply from '@/components/OperationSupply.vue';
import OperationChildStatus from '@/components/OperationChildStatus.vue';
import OperationPmInstaller from '@/components/OperationPmInstaller.vue';
import OperationSiteInspection from '@/components/OperationSiteInspection.vue';
import OperationAuth from '@/components/OperationAuth.vue';
import OperationPlan from '@/components/OperationPlan.vue';
import OperationPlanDate from '@/components/OperationPlanDate.vue';
import OperationPraticesAndVerifications from '@/components/OperationPraticesAndVerifications.vue';
import OperationAssignments from '@/components/OperationAssignments.vue';
import OperationItems from '@/components/OperationItems.vue';
import OperationMaterialsTargetDate from '@/components/OperationMaterialsTargetDate.vue';
import OperationSub from '@/components/OperationSub.vue';
import OperationInstallationDate from '@/components/OperationInstallationDate.vue';
import OperationTestingDate from '@/components/OperationTestingDate.vue';
import OperationDico from '@/components/operations/OperationDico.vue';
import OperationDocs from '@/components/OperationDocs.vue';
import OperationConnection from '@/components/OperationConnection.vue';
import OperationCommissioning from '@/components/operations/OperationCommissioning.vue';
import OperationDogane from '@/components/OperationDogane.vue';
import OperationReadyForFinalPayment from '@/components/OperationReadyForFinalPayment.vue';
import OperationEnd from '@/components/OperationEnd.vue';
import ProjectItemPlaceholder from '@/components/ProjectItemPlaceholder.vue';
import EditTaskDialog from '@/components/EditTaskDialog.vue';
import EditLeadPaymentsDialog from '@/components/EditLeadPaymentsDialog.vue';
import EditLeadUsersDialog from '@/components/EditLeadUsersDialog.vue';
import MultiBoolSelect from '@/components/MultiBoolSelect.vue';
import AssignmentFilterToggle from '@/components/AssignmentFilterToggle.vue';
import TimeoutButton from '@/components/TimeoutButton.vue';
import UserGroups from '@/components/UserGroups.vue';
import SaveFilterPresetMenu from '@/components/SaveFilterPresetMenu.vue';
import LoadFilterPresetMenu from '@/components/LoadFilterPresetMenu.vue';
import OperationEneaPractice from '@/components/operations/OperationEneaPractice.vue';
import OperationChildActions from '@/components/operations/OperationChildActions.vue';
import {
  PermissionCode, User, OperationsPool, OperationsList, LeadType, Operation, DataTableHeaderOptions,
  LeadStatus, Category, Tag, LogicType, InstallationStatus,
  InstallationDateStatus, WarehouseType, BoxOutcomeType, OperationInfo, ShipmentStatus,
  BoxStatusType,
  ConnectionStatusType,
  ArchivedStatus, PracticeAssigneesStatus,
  ReadyForFinalPaymentFilter,
  ShipmentCompletedFilter,
  InternetConnectionFilter,
  ServiceConfirmFilter,
  InverterConnectedFilter,
  TestingDateConfirmFilter,
  DocsSentToPartnerFilter,
} from '@/types';
import { getProvince } from '@/lib/italy';
import { operationInfoFromOperation } from '@/helpers';
import ArchiveOperationDialog from '@/components/operations/ArchiveOperationDialog.vue';

moment.locale('it');

@Component({
  components: {
    Loading,
    PageHeader,
    DataTableHeader,
    OperationLead,
    OperationTags,
    OperationPayments,
    OperationFinalPaymentDate,
    OperationCustomer,
    OperationProvince,
    OperationUnifiedDates,
    OperationSupply,
    OperationChildStatus,
    OperationPmInstaller,
    OperationSiteInspection,
    OperationAuth,
    OperationSub,
    OperationInstallationDate,
    OperationTestingDate,
    OperationDico,
    OperationDocs,
    OperationConnection,
    OperationCommissioning,
    OperationPlan,
    OperationPlanDate,
    OperationPraticesAndVerifications,
    OperationAssignments,
    OperationMaterialsTargetDate,
    OperationItems,
    OperationDogane,
    OperationReadyForFinalPayment,
    OperationEnd,
    EditTaskDialog,
    EditLeadPaymentsDialog,
    EditLeadUsersDialog,
    ProjectItemPlaceholder,
    MultiBoolSelect,
    AssignmentFilterToggle,
    TimeoutButton,
    UserGroups,
    SaveFilterPresetMenu,
    LoadFilterPresetMenu,
    ArchiveOperationDialog,
    OperationEneaPractice,
    OperationChildActions,
  },
})
export default class Operations extends Vue {
  firstTimeUpdating = true
  delayedUpdating: boolean | null = null

  editTaskDialog = false
  editPaymentsDialog = false
  editChildUsersDialog = false
  archiveOperationDialog = false

  showUpdateRequired = false

  unsubscribeOperationUpdates: (() => void) | null = null

  selectedName: string | null = null
  selectedProjectId: number | null = null
  selectedChildProjectId: number | null = null

  breadcrumbs = [
    {
      text: 'Commesse',
      exact: true,
      to: { name: 'Operations' },
    },
  ]

  filters = {
    search: '',
    requester: null,
    owner: [] as number[],
    ownerLogic: 'OR' as LogicType,
    ownerNegated: [] as (number | string)[],
    practiceAssignees: [] as (number | null)[],
    practiceAssigneesLogic: 'OR' as LogicType,
    practiceAssigneesStatus: null as PracticeAssigneesStatus | null,
    practiceAssigneesNegated: [] as (number | string)[],
    projectAssignees: [] as (number | null)[],
    projectAssigneesLogic: 'OR' as LogicType,
    projectAssigneesStatus: null as PracticeAssigneesStatus | null,
    projectAssigneesNegated: [] as (number | string)[],
    eneaAssignees: [] as (number | null)[],
    eneaAssigneesLogic: 'OR' as LogicType,
    eneaAssigneesStatus: null as PracticeAssigneesStatus | null,
    eneaAssigneesNegated: [] as (number | string)[],
    doganeAssignees: [] as (number | null)[],
    doganeAssigneesLogic: 'OR' as LogicType,
    doganeAssigneesStatus: null as PracticeAssigneesStatus | null,
    doganeAssigneesNegated: [] as (number | string)[],
    installerAssignees: [] as (number | null)[],
    installerAssigneesLogic: 'OR' as LogicType,
    installerAssigneesStatus: null as PracticeAssigneesStatus | null,
    installerAssigneesNegated: [] as (number | string)[],
    categories: [] as number[],
    categoriesLogic: 'AND' as LogicType,
    categoriesNegated: [] as (number | string)[],
    tags: [] as number[],
    tagsLogic: 'AND' as LogicType,
    tagsNegated: [] as (number | string)[],
    provinces: [] as string[],
    provincesLogic: 'AND' as LogicType,
    provincesNegated: [] as (number | string)[],
    childType: [] as LeadType[],
    projectStatus: [] as BoxStatusType[],
    warehouse: [] as WarehouseType[],
    shipmentStatus: [] as ShipmentStatus[],

    partialInstallationStatus: null as InstallationStatus | null,
    partialInstallationDateStatus: null as InstallationDateStatus | null,
    installationStatus: null as InstallationStatus | null,
    installationDateStatus: null as InstallationDateStatus | null,

    dicoStatus: [] as BoxStatusType[],

    readyForFinalPayment: null as ReadyForFinalPaymentFilter | null,
    shipmentCompleted: null as ShipmentCompletedFilter | null,
    internetConnection: null as InternetConnectionFilter | null,
    serviceConfirm: null as ServiceConfirmFilter | null,
    inverterConnected: null as InverterConnectedFilter | null,
    testingDateConfirm: null as TestingDateConfirmFilter | null,
    docsSentToPartner: null as DocsSentToPartnerFilter | null,

    testingOutcome: [] as (BoxOutcomeType | 'nodate')[],
    egridConnectionStatus: [] as ConnectionStatusType[],
    archivedStatus: [] as ArchivedStatus[],
    childStatus: [] as LeadStatus[],
    fatherStatus: [] as LeadStatus[],
    taskO: [] as string[],
    taskCm: [] as string[],
    opType: [] as string[],
    payments: [] as number[],
    missingFinishings: [] as BoxStatusType[],
    sortBy: [] as string[],
    sortDesc: [] as boolean[] | string[],
    dates: {
      value: null,
      begin: null,
      end: null,
    } as {
      value: string | null;
      begin: Date | null | false;
      end: Date | null | false;
    },

    // Filtri per la ricerca testuale (utilizzato per la ricerca sulla fornitura)
    searchValue: null as string | null,
    searchItems: [] as string[],
    searchLogic: 'OR' as 'AND' | 'OR',
    searchExclude: null as string | null,
  }

  previousSearch = ''
  applyFiltersTimeout = 0
  applyFiltersDisabled = true
  applyFiltersCount = 0

  // Segnala ai componenti figli (es. AssignmentFilterToggle) che l'idratazione
  // dei filtri da currentFilters nel created() async è completata: prima di
  // allora this.filters contiene solo i valori default del data.
  filtersHydrated = false

  // Incrementato quando il parent modifica i filtri programmaticamente
  // (es. caricamento preset) per forzare i componenti figli a ricalcolare
  // il loro stato UI derivato (es. activeTypeIds di AssignmentFilterToggle).
  filtersSyncToken = 0

  options = {} as {
    sortBy?: string[];
    sortDesc?: boolean[] | string[];
  }

  timeoutSearchFilter: number | undefined = undefined

  headers: DataTableHeaderOptions[] = []

  // true: sono disponibili altri risultati da recuperare
  // false: sono stati recuperati tutti i risultati
  more = true

  tableElements: HTMLCollectionOf<Element> | null = null
  tableElement: Element | null = null

  headerElements: HTMLCollectionOf<Element> | null = null
  headerElement: HTMLElement | null = null

  contentElements: HTMLCollectionOf<Element> | null = null
  contentElement: HTMLElement | null = null

  downloading = false
  hasHorizontalScroll = false

  // Il valore del filtro `shipmentStatus` (da usare per il watch)
  get filtersShipmentStatus(): ShipmentStatus[] {
    return this.filters.shipmentStatus;
  }

  // Il valore del filtro `installationStatus` (da usare per il watch)
  get filtersInstallationStatus(): InstallationStatus | null {
    return this.filters.installationStatus;
  }

  // Il valore del filtro `fatherStatus` (da usare per il watch)
  get filtersFatherStatus(): LeadStatus[] {
    return this.filters.fatherStatus;
  }

  // Tiene d'occhio il valore del filtro `shipmentStatus`
  // per fare in modo che il valore `planned` sia sempre usato da solo
  @Watch('filtersShipmentStatus')
  onFiltersShipmentStatusChange(val: ShipmentStatus[], oldVal: ShipmentStatus[]) {
    // Se è stato aggiunto il valore `planned` (non presente in `oldVal`)...
    if (val.includes('planned') && !oldVal.includes('planned') && val.length > 1) {
      // ... elimina dall'array tutti gli altri valori
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() val =`, val); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() oldVal =`, oldVal); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() Seleziono soltanto 'planned'`); // eslint-disable-line no-console

      this.$set(this.filters, 'shipmentStatus', ['planned']);
    }

    // Se è stato aggiunto il valore `not-planned` (non presente in `oldVal`)...
    if (val.includes('not-planned') && !oldVal.includes('not-planned') && val.includes('planned')) {
      // ... elimina il valore `planned` se presente ma lascia eventuali altri valori
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() val =`, val); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() oldVal =`, oldVal); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() Rimuovo 'planned'`); // eslint-disable-line no-console

      this.$set(this.filters, 'shipmentStatus', this.filters.shipmentStatus.filter((v) => v !== 'planned'));
    }

    // Se è stato aggiunto il valore `partially-planned` (non presente in `oldVal`)...
    if (val.includes('partially-planned') && !oldVal.includes('partially-planned') && val.includes('planned')) {
      // ... elimina il valore `planned` se presente ma lascia eventuali altri valori
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() val =`, val); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() oldVal =`, oldVal); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersShipmentStatusChange() Rimuovo 'planned'`); // eslint-disable-line no-console

      this.$set(this.filters, 'shipmentStatus', this.filters.shipmentStatus.filter((v) => v !== 'planned'));
    }
  }

  // Tiene d'occhio il valore del filtro `installationStatus`
  // per fare in modo che il valore `done` disattivi i filtri `installationDateStatus`,
  // `partialInstallationStatus` e `partialInstallationDateStatus`.
  @Watch('filtersInstallationStatus')
  onFiltersInstallationStatusChange(val: InstallationStatus | null, oldVal: InstallationStatus | null) {
    // Se è stato aggiunto il valore `done` (non presente in `oldVal`)...
    if (val === 'done' && oldVal !== 'done') {
      // ... elimina i valori `partial` e `not-partial` se presenti
      console.log(`${this.constructor.name}: onFiltersInstallationStatusChange() val =`, val); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersInstallationStatusChange() oldVal =`, oldVal); // eslint-disable-line no-console

      this.$set(this.filters, 'partialInstallationDateStatus', null);
      this.$set(this.filters, 'partialInstallationStatus', null);
      this.$set(this.filters, 'installationDateStatus', null);
    }
  }

  // Tiene d'occhio il valore del filtro `fatherStatus`
  // per fare in modo che se impostato i filtri `taskO` e `taskCm` vengano resettati.
  @Watch('filtersFatherStatus')
  onFiltersFatherStatusChange(val: LeadStatus[], oldVal: LeadStatus[]) {
    // Se è stato aggiunto il valore `done` (non presente in `oldVal`)...
    if (val.length > 0 && oldVal.length === 0) {
      // ... elimina i valori `taskO` e `taskCm` se presenti
      console.log(`${this.constructor.name}: onFiltersFatherStatusChange() val =`, val); // eslint-disable-line no-console
      console.log(`${this.constructor.name}: onFiltersFatherStatusChange() oldVal =`, oldVal); // eslint-disable-line no-console

      // if (Array.isArray(this.filters.taskO) && this.filters.taskO.length > 0) this.$set(this.filters, 'taskO', []);
      if (
        (!Array.isArray(this.filters.taskCm) || this.filters.taskCm.length === 0)
        && (!Array.isArray(this.filters.taskO) || this.filters.taskO.length === 0)
      ) this.$set(this.filters, 'taskCm', ['Cm=c']);
    }
  }

  @Watch('updating')
  onUpdatingChange(val: boolean, oldVal: boolean) {
    if (!val && oldVal) {
      setTimeout(() => {
        this.delayedUpdating = false;
        this.firstTimeUpdating = false;
      }, 0);
    } else {
      this.delayedUpdating = true;
    }
  }

  @Watch('updateRequired')
  onUpdateRequiredChange(val: boolean) {
    if (val === true) this.showUpdateRequired = true;
  }

  get assignmentTypesCount(): number {
    return this.$store.getters.getAssignmentTypes.length;
  }

  // Rete di sicurezza: se gli assignment types arrivano dopo il primo
  // syncCellLineHeights() (es. fetch lazy non atteso, re-render via socket), le
  // celle assegnatari cambiano altezza. Ri-sincronizza per evitare overflow.
  @Watch('assignmentTypesCount')
  onAssignmentTypesCountChange() {
    this.$nextTick(() => this.syncCellLineHeights());
  }

  onOptionsChange() {
    console.log('Operations: onOptionsChange() options =', this.options); // eslint-disable-line no-console

    if (this.options?.sortBy) {
      this.$set(
        this.filters,
        'sortBy',
        Array.isArray(this.options.sortBy)
          ? this.options.sortBy
          : [],
      );
    }

    if (this.options?.sortDesc) {
      this.$set(
        this.filters,
        'sortDesc',
        Array.isArray(this.options.sortDesc)
          ? this.options.sortDesc
          : [],
      );
    }

    this.filtersNeedsAnUpdate();
  }

  get operations(): OperationsList {
    return this.$store.getters.operationsList;
  }

  get orderedOperations() {
    return this.operations.sort((a: Operation, b: Operation) => {
      let value = 'installationDate';
      let isDesc = false;

      const sortBy = 'sortBy' in this.options
        && Array.isArray(this.options.sortBy) ? this.options.sortBy : [];
      const sortDesc = 'sortDesc' in this.options
        && Array.isArray(this.options.sortDesc) ? this.options.sortDesc : [];
      const childType = 'childType' in this.filters
        && Array.isArray(this.filters.childType) ? this.filters.childType : [];

      if (sortBy.includes('lastPayment')) {
        value = 'latestPaymentDate';

        const index = sortBy.indexOf('lastPayment');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';
      } else
      if (sortBy.includes('targetDate')) {
        value = 'targetDate';

        const index = sortBy.indexOf('targetDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';
      } else
      if (sortBy.includes('siteInspectionDate')) {
        value = 'siteInspectionDate';

        const index = sortBy.indexOf('siteInspectionDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';
      } else
      if (sortBy.includes('installationDate')) {
        const index = sortBy.indexOf('installationDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';

        if (childType.includes('termica-figlia') && !childType.includes('elettrica-figlia')) {
          // mostra solo le termica-figlia
          value = 'tOrderInstallationDate';
        } else
        if (childType.includes('elettrica-figlia') && !childType.includes('termica-figlia')) {
          // mostra solo le elettrica-figlia
          value = 'eOrderInstallationDate';
        } else {
          value = isDesc ? 'maxInstallationDate' : 'minInstallationDate';
        }
      } else
      if (sortBy.includes('dicoDate')) {
        const index = sortBy.indexOf('dicoDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';

        if (childType.includes('termica-figlia') && !childType.includes('elettrica-figlia')) {
          // mostra solo le termica-figlia
          value = 'tDicoDate';
        } else
        if (childType.includes('elettrica-figlia') && !childType.includes('termica-figlia')) {
          // mostra solo le elettrica-figlia
          value = 'eDicoDate';
        } else {
          value = isDesc ? 'maxDicoDate' : 'minDicoDate';
        }
      } else
      if (sortBy.includes('planDate')) {
        const index = sortBy.indexOf('planDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';

        if (childType.includes('termica-figlia') && !childType.includes('elettrica-figlia')) {
          // mostra solo le termica-figlia
          value = 'tPlanDate';
        } else
        if (childType.includes('elettrica-figlia') && !childType.includes('termica-figlia')) {
          // mostra solo le elettrica-figlia
          value = 'ePlanDate';
        } else {
          value = isDesc ? 'maxPlanDate' : 'minPlanDate';
        }
      } else
      if (sortBy.includes('materialsTargetDate')) {
        const index = sortBy.indexOf('materialsTargetDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';

        if (childType.includes('termica-figlia') && !childType.includes('elettrica-figlia')) {
          // mostra solo le termica-figlia
          value = 'tMaterialsTargetDate';
        } else
        if (childType.includes('elettrica-figlia') && !childType.includes('termica-figlia')) {
          // mostra solo le elettrica-figlia
          value = 'eMaterialsTargetDate';
        } else {
          value = isDesc ? 'maxMaterialsTargetDate' : 'minMaterialsTargetDate';
        }
      } else
      if (sortBy.includes('connectionDate')) {
        value = 'connectionDate';

        const index = sortBy.indexOf('connectionDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';
      } else
      if (sortBy.includes('commissioningDate')) {
        value = 'commissioningDate';

        const index = sortBy.indexOf('commissioningDate');
        isDesc = index in sortDesc && sortDesc[index] !== false && sortDesc[index] !== 'false';
      }

      // Tutte gli altri valori possono essere ordinati allo stesso modo

      if (a[value] === null && b[value] !== null) {
        // return isDesc ? 1 : -1;
        return 1;
      }
      if (a[value] !== null && b[value] === null) {
        // return isDesc ? -1 : 1;
        return -1;
      }
      if (a[value] === null && b[value] === null) {
        return 0;
      }

      if (moment(a[value]).isBefore(b[value])) {
        return isDesc ? 1 : -1;
      }
      if (moment(b[value]).isBefore(a[value])) {
        return isDesc ? -1 : 1;
      }

      return 0;
    });
  }

  get currentFilters() {
    return this.$store.getters.currentOperationsFilters;
  }

  get pool(): OperationsPool {
    return this.$store.getters.currentOperationsPool;
  }

  get updating() {
    return this.$store.getters.areOperationsUpdating;
  }

  get updateRequired() {
    return this.$store.getters.areOperationsUpdateRequired;
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  get operationsCount(): number {
    return this.$store.getters.currentOperationsCount;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get users(): User[] {
    return this.$store.getters.users ?? [];
  }

  get categories(): Category[] {
    return this.$store.getters.categories;
  }

  get visibleCategories() {
    return Array.isArray(this.categories)
      ? this.categories.filter((c) => !c.hidden && c.isActive)
      : [];
  }

  get tags(): Tag[] {
    return this.$store.getters.tags;
  }

  get visibleTags() {
    return Array.isArray(this.tags)
      ? this.tags.filter((t) => !t.hidden && t.isActive)
      : [];
  }

  get provinces() {
    return getProvince()
      .map((p) => ({ name: p.text, id: p.value }));
  }

  get assignmentDateFieldNames(): string[] {
    const types = this.$store.getters.getAssignmentTypes;
    return types
      .filter((t: any) => this.hasPermission(t.permissionShow))
      .map((t: any) => `${t.id}AssignedDate`);
  }

  get assignmentDateFieldLabels(): string[] {
    const types = this.$store.getters.getAssignmentTypes;
    return types
      .filter((t: any) => this.hasPermission(t.permissionShow))
      .map((t: any) => `Data ${t.label.toLowerCase()}`);
  }

  async created() {
    console.log('Operations: created()'); // eslint-disable-line no-console

    this.initHeaders();

    await this.$store.dispatch('initOperationsFilters');

    if (this.currentFilters?.search) {
      this.$set(this.filters, 'search', this.currentFilters.search);
      this.previousSearch = this.currentFilters.search;
    }

    if (this.currentFilters?.requester) {
      this.$set(this.filters, 'requester', this.currentFilters.requester);
    }

    if (this.currentFilters?.owner) {
      this.$set(
        this.filters,
        'owner',
        Array.isArray(this.currentFilters.owner)
          ? this.currentFilters.owner
          : [],
      );
    }

    if (this.currentFilters?.ownerLogic) {
      this.$set(this.filters, 'ownerLogic', this.currentFilters.ownerLogic);
    }

    if (this.currentFilters?.categories) {
      this.$set(
        this.filters,
        'categories',
        Array.isArray(this.currentFilters.categories)
          ? this.currentFilters.categories
          : [],
      );
    }

    if (this.currentFilters?.categoriesLogic) {
      this.$set(this.filters, 'categoriesLogic', this.currentFilters.categoriesLogic);
    }

    if (this.currentFilters?.categoriesNegated !== undefined && Array.isArray(this.currentFilters.categoriesNegated)) {
      this.$set(this.filters, 'categoriesNegated', this.currentFilters.categoriesNegated);
    }

    if (this.currentFilters?.tags) {
      this.$set(
        this.filters,
        'tags',
        Array.isArray(this.currentFilters.tags)
          ? this.currentFilters.tags
          : [],
      );
    }

    if (this.currentFilters?.tagsLogic) {
      this.$set(this.filters, 'tagsLogic', this.currentFilters.tagsLogic);
    }

    if (this.currentFilters?.tagsNegated !== undefined && Array.isArray(this.currentFilters.tagsNegated)) {
      this.$set(this.filters, 'tagsNegated', this.currentFilters.tagsNegated);
    }

    if (this.currentFilters?.provinces) {
      this.$set(
        this.filters,
        'provinces',
        Array.isArray(this.currentFilters.provinces)
          ? this.currentFilters.provinces
          : [],
      );
    }

    if (this.currentFilters?.provincesLogic) {
      this.$set(this.filters, 'provincesLogic', this.currentFilters.provincesLogic);
    }

    if (this.currentFilters?.provincesNegated !== undefined && Array.isArray(this.currentFilters.provincesNegated)) {
      this.$set(this.filters, 'provincesNegated', this.currentFilters.provincesNegated);
    }

    if (this.currentFilters?.ownerNegated !== undefined && Array.isArray(this.currentFilters.ownerNegated)) {
      this.$set(this.filters, 'ownerNegated', this.currentFilters.ownerNegated);
    }

    // Filtri assegnatari practice
    this.$set(this.filters, 'practiceAssigneesLogic', this.currentFilters.practiceAssigneesLogic ?? 'OR');
    this.$set(
      this.filters,
      'practiceAssignees',
      this.currentFilters.practiceAssignees && Array.isArray(this.currentFilters.practiceAssignees)
        ? this.currentFilters.practiceAssignees
        : [],
    );
    if (this.currentFilters?.practiceAssigneesNegated !== undefined
      && Array.isArray(this.currentFilters.practiceAssigneesNegated)) {
      this.$set(this.filters, 'practiceAssigneesNegated', this.currentFilters.practiceAssigneesNegated);
    }
    this.$set(this.filters, 'practiceAssigneesStatus', this.currentFilters.practiceAssigneesStatus ?? null);

    // Filtri assegnatari project
    this.$set(this.filters, 'projectAssigneesLogic', this.currentFilters.projectAssigneesLogic ?? 'OR');
    this.$set(
      this.filters,
      'projectAssignees',
      this.currentFilters.projectAssignees && Array.isArray(this.currentFilters.projectAssignees)
        ? this.currentFilters.projectAssignees
        : [],
    );
    if (this.currentFilters?.projectAssigneesNegated !== undefined
      && Array.isArray(this.currentFilters.projectAssigneesNegated)) {
      this.$set(this.filters, 'projectAssigneesNegated', this.currentFilters.projectAssigneesNegated);
    }
    this.$set(this.filters, 'projectAssigneesStatus', this.currentFilters.projectAssigneesStatus ?? null);

    // Filtri assegnatari enea
    this.$set(this.filters, 'eneaAssigneesLogic', this.currentFilters.eneaAssigneesLogic ?? 'OR');
    this.$set(
      this.filters,
      'eneaAssignees',
      this.currentFilters.eneaAssignees && Array.isArray(this.currentFilters.eneaAssignees)
        ? this.currentFilters.eneaAssignees
        : [],
    );
    if (this.currentFilters?.eneaAssigneesNegated !== undefined
      && Array.isArray(this.currentFilters.eneaAssigneesNegated)) {
      this.$set(this.filters, 'eneaAssigneesNegated', this.currentFilters.eneaAssigneesNegated);
    }
    this.$set(this.filters, 'eneaAssigneesStatus', this.currentFilters.eneaAssigneesStatus ?? null);

    // Filtri assegnatari dogane
    this.$set(this.filters, 'doganeAssigneesLogic', this.currentFilters.doganeAssigneesLogic ?? 'OR');
    this.$set(
      this.filters,
      'doganeAssignees',
      this.currentFilters.doganeAssignees && Array.isArray(this.currentFilters.doganeAssignees)
        ? this.currentFilters.doganeAssignees
        : [],
    );
    if (this.currentFilters?.doganeAssigneesNegated !== undefined
      && Array.isArray(this.currentFilters.doganeAssigneesNegated)) {
      this.$set(this.filters, 'doganeAssigneesNegated', this.currentFilters.doganeAssigneesNegated);
    }
    this.$set(this.filters, 'doganeAssigneesStatus', this.currentFilters.doganeAssigneesStatus ?? null);

    // Filtri assegnatari installer
    this.$set(this.filters, 'installerAssigneesLogic', this.currentFilters.installerAssigneesLogic ?? 'OR');
    this.$set(
      this.filters,
      'installerAssignees',
      this.currentFilters.installerAssignees && Array.isArray(this.currentFilters.installerAssignees)
        ? this.currentFilters.installerAssignees
        : [],
    );
    if (this.currentFilters?.installerAssigneesNegated !== undefined
      && Array.isArray(this.currentFilters.installerAssigneesNegated)) {
      this.$set(this.filters, 'installerAssigneesNegated', this.currentFilters.installerAssigneesNegated);
    }
    this.$set(this.filters, 'installerAssigneesStatus', this.currentFilters.installerAssigneesStatus ?? null);

    if (this.currentFilters?.childType) {
      this.$set(
        this.filters,
        'childType',
        Array.isArray(this.currentFilters.childType)
          ? this.currentFilters.childType
          : [],
      );
    }

    if (this.currentFilters?.projectStatus) {
      this.$set(
        this.filters,
        'projectStatus',
        Array.isArray(this.currentFilters.projectStatus)
          ? this.currentFilters.projectStatus
          : [],
      );
    }

    if (this.currentFilters?.warehouse) {
      this.$set(
        this.filters,
        'warehouse',
        Array.isArray(this.currentFilters.warehouse)
          ? this.currentFilters.warehouse
          : [],
      );
    }

    if (this.currentFilters?.shipmentStatus) {
      this.$set(
        this.filters,
        'shipmentStatus',
        Array.isArray(this.currentFilters.shipmentStatus)
          ? this.currentFilters.shipmentStatus
          : [],
      );
    }

    // partialInstallationDateStatus
    if (this.currentFilters?.partialInstallationDateStatus) {
      this.$set(
        this.filters,
        'partialInstallationDateStatus',
        this.currentFilters.partialInstallationDateStatus,
      );
    }

    // partialInstallationStatus
    if (this.currentFilters?.partialInstallationStatus) {
      this.$set(
        this.filters,
        'partialInstallationStatus',
        this.currentFilters.partialInstallationStatus,
      );
    }

    // installationDateStatus
    if (this.currentFilters?.installationDateStatus) {
      this.$set(
        this.filters,
        'installationDateStatus',
        this.currentFilters.installationDateStatus,
      );
    }

    // installationStatus
    if (this.currentFilters?.installationStatus) {
      this.$set(
        this.filters,
        'installationStatus',
        this.currentFilters.installationStatus,
      );
    }

    if (this.currentFilters?.missingFinishings !== undefined) {
      // Migrazione legacy: vecchi preset salvati come boolean → ['todo'].
      const v = this.currentFilters.missingFinishings as unknown;
      let migrated: BoxStatusType[] = [];
      if (v === true) {
        migrated = ['todo'];
      } else if (Array.isArray(v)) {
        migrated = (v as BoxStatusType[]).filter((x) => x === 'todo' || x === 'done');
      }
      this.$set(this.filters, 'missingFinishings', migrated);
    }

    // dicoStatus
    if (this.currentFilters?.dicoStatus) {
      this.$set(
        this.filters,
        'dicoStatus',
        Array.isArray(this.currentFilters.dicoStatus)
          ? this.currentFilters.dicoStatus
          : [],
      );
    }

    // readyForFinalPayment
    if (this.currentFilters?.readyForFinalPayment !== undefined) {
      const v = this.currentFilters.readyForFinalPayment;
      this.$set(
        this.filters,
        'readyForFinalPayment',
        (v === 'ready' || v === 'not-ready') ? v : null,
      );
    }

    // shipmentCompleted
    if (this.currentFilters?.shipmentCompleted !== undefined) {
      const v = this.currentFilters.shipmentCompleted;
      this.$set(
        this.filters,
        'shipmentCompleted',
        (v === 'completed' || v === 'not-completed') ? v : null,
      );
    }

    // internetConnection
    if (this.currentFilters?.internetConnection !== undefined) {
      const v = this.currentFilters.internetConnection;
      this.$set(
        this.filters,
        'internetConnection',
        (v === 'tested' || v === 'not-tested') ? v : null,
      );
    }

    // serviceConfirm
    if (this.currentFilters?.serviceConfirm !== undefined) {
      const v = this.currentFilters.serviceConfirm;
      this.$set(
        this.filters,
        'serviceConfirm',
        (v === 'confirmed' || v === 'not-confirmed') ? v : null,
      );
    }

    // inverterConnected
    if (this.currentFilters?.inverterConnected !== undefined) {
      const v = this.currentFilters.inverterConnected;
      this.$set(
        this.filters,
        'inverterConnected',
        (v === 'connected' || v === 'not-connected') ? v : null,
      );
    }

    // testingDateConfirm
    if (this.currentFilters?.testingDateConfirm !== undefined) {
      const v = this.currentFilters.testingDateConfirm;
      this.$set(
        this.filters,
        'testingDateConfirm',
        (v === 'confirmed' || v === 'not-confirmed') ? v : null,
      );
    }

    // docsSentToPartner
    if (this.currentFilters?.docsSentToPartner !== undefined) {
      const v = this.currentFilters.docsSentToPartner;
      this.$set(
        this.filters,
        'docsSentToPartner',
        (v === 'sent' || v === 'not-sent') ? v : null,
      );
    }

    if (this.currentFilters?.testingOutcome) {
      this.$set(
        this.filters,
        'testingOutcome',
        Array.isArray(this.currentFilters.testingOutcome)
          ? this.currentFilters.testingOutcome
          : [],
      );
    }

    if (this.currentFilters?.egridConnectionStatus) {
      this.$set(
        this.filters,
        'egridConnectionStatus',
        Array.isArray(this.currentFilters.egridConnectionStatus)
          ? this.currentFilters.egridConnectionStatus
          : [],
      );
    }

    if (this.currentFilters?.archivedStatus) {
      this.$set(
        this.filters,
        'archivedStatus',
        Array.isArray(this.currentFilters.archivedStatus)
          ? this.currentFilters.archivedStatus
          : [],
      );
    }

    if (this.currentFilters?.fatherStatus) {
      this.$set(
        this.filters,
        'fatherStatus',
        Array.isArray(this.currentFilters.fatherStatus)
          ? this.currentFilters.fatherStatus
          : [],
      );
    }

    if (this.currentFilters?.taskO) {
      this.$set(
        this.filters,
        'taskO',
        Array.isArray(this.currentFilters.taskO)
          ? this.currentFilters.taskO
          : [],
      );
    }

    if (this.currentFilters?.taskCm) {
      this.$set(
        this.filters,
        'taskCm',
        Array.isArray(this.currentFilters.taskCm)
          ? this.currentFilters.taskCm
          : [],
      );
    }

    if (this.currentFilters?.childStatus) {
      this.$set(
        this.filters,
        'childStatus',
        Array.isArray(this.currentFilters.childStatus)
          ? this.currentFilters.childStatus
          : [],
      );
    }

    if (this.currentFilters?.opType) {
      this.$set(
        this.filters,
        'opType',
        Array.isArray(this.currentFilters.opType)
          ? this.currentFilters.opType
          : [],
      );
    }

    if (this.currentFilters?.payments) {
      this.$set(
        this.filters,
        'payments',
        Array.isArray(this.currentFilters.payments)
          ? this.currentFilters.payments
          : [],
      );
    }

    if (this.currentFilters?.sortBy) {
      this.$set(
        this.filters,
        'sortBy',
        Array.isArray(this.currentFilters.sortBy)
          ? this.currentFilters.sortBy
          : [],
      );
      this.$set(
        this.options,
        'sortBy',
        Array.isArray(this.currentFilters.sortBy)
          ? this.currentFilters.sortBy
          : [],
      );
    }

    if (this.currentFilters?.sortDesc) {
      this.$set(
        this.filters,
        'sortDesc',
        Array.isArray(this.currentFilters.sortDesc)
          ? this.currentFilters.sortDesc
          : [],
      );
      this.$set(
        this.options,
        'sortDesc',
        Array.isArray(this.currentFilters.sortDesc)
          ? this.currentFilters.sortDesc
          : [],
      );
    }

    if (this.currentFilters?.dates) {
      this.$set(this.filters, 'dates', this.currentFilters.dates);
    }

    if (this.currentFilters?.searchItems) {
      this.$set(
        this.filters,
        'searchItems',
        Array.isArray(this.currentFilters.searchItems)
          ? this.currentFilters.searchItems
          : [],
      );
    }

    if (this.currentFilters?.searchValue) {
      this.$set(this.filters, 'searchValue', this.currentFilters.searchValue);
    }

    if (this.currentFilters.searchLogic === 'AND' || this.currentFilters.searchLogic === 'OR') {
      this.$set(this.filters, 'searchLogic', this.currentFilters.searchLogic);
    }
    if (this.currentFilters.searchExclude !== undefined) {
      this.$set(this.filters, 'searchExclude', this.currentFilters.searchExclude ?? null);
    }

    // Segnala ai componenti figli (es. AssignmentFilterToggle) che i filtri
    // locali sono stati idratati da currentFilters e possono essere letti
    // senza leggere valori default pre-idratazione.
    this.filtersHydrated = true;

    // Inizializza i preset dei filtri
    await this.$store.dispatch('initOperationsFilterPresets');

    // Carica gli assignment types PRIMA del primo getOperations/sync: le celle
    // assegnatari (OperationPmInstaller, OperationAssignments) gatano le proprie
    // righe su getAssignmentTypes. Se non sono presenti al momento di
    // syncCellLineHeights(), l'altezza riga viene fissata su un contenuto più
    // corto e le righe installatore — comparse dopo il fetch lazy — sforano la
    // quota congelata. Caricandoli qui le righe sono renderizzate al primo paint.
    if (this.$store.getters.getAssignmentTypes.length === 0) {
      await this.$store.dispatch('fetchAssignmentTypes');
    }

    this.filtersUpdated();
  }

  mounted() {
    console.log('Operations: mounted()'); // eslint-disable-line no-console

    // Aggiorna la data/ora dell'ultima attività dell'utente corrente
    this.$store.dispatch('updateLastActivity');

    // Una commessa aggiornata da sola (dialog incarichi, socket leadUpdated)
    // cambia l'altezza delle sue celle, ma le righe restano fissate
    // sull'altezza calcolata al caricamento e il contenuto sfora sulla figlia
    // successiva. Ri-sincronizza solo la commessa toccata.
    this.unsubscribeOperationUpdates = this.$store.subscribe((mutation) => {
      let operationId: number | undefined;
      if (mutation.type === 'addOperationToPool') {
        operationId = mutation.payload?.operation?.id;
      } else if (mutation.type === 'updateOperationChildFields') {
        operationId = mutation.payload?.operationId;
      }
      if (operationId === undefined) return;

      this.$nextTick(() => this.syncCellLineHeights(operationId));
    });

    this.$nextTick(() => {
      // Recupera un riferimento alla tabella nel DOM
      this.tableElements = document.getElementsByClassName('v-data-table__wrapper');

      // Recupera un riferimento al contenitore dei filtri nel DOM
      this.headerElements = document.getElementsByClassName('view-operations-header');

      // Recupera un riferimento al contenitore dei filtri nel DOM
      this.contentElements = document.getElementsByClassName('view-operations-content');
    });
  }

  async beforeDestroy() {
    console.log(`${this.constructor.name}: beforeDestroy() - Deseleziona la lead selezionata`); // eslint-disable-line no-console

    this.$store.dispatch('unselectLead');
  }

  @Watch('tableElements')
  onTableElements(val: HTMLCollectionOf<Element> | null) {
    console.log('Operations: onTableElements()'); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.tableElement = val[0];
    }
  }

  @Watch('tableElement')
  onTableElement(val: Element | null) {
    console.log('Operations: onTableElement()'); // eslint-disable-line no-console

    if (val !== null) {
      // tableElement è già il .v-data-table__wrapper
      const wrapper = val as HTMLElement;

      // Aggiungi un unico listener per gestire sia scroll verticale che orizzontale
      wrapper.addEventListener('scroll', this.onTableScroll);

      // Controlla lo stato iniziale
      this.$nextTick(() => {
        this.onHorizontalScroll();
      });
    }
  }

  // Funzione wrapper che gestisce sia lo scroll verticale che orizzontale
  onTableScroll() {
    this.onScroll();
    this.onHorizontalScroll();
  }

  @Watch('headerElements')
  onHeaderElements(val: HTMLCollectionOf<HTMLElement> | null) {
    console.log('Operations: onHeaderElements()'); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.headerElement = val[0];
    }
  }

  @Watch('headerElement')
  onHeaderElement(val: HTMLElement | null) {
    console.log('Operations: onHeaderElement()'); // eslint-disable-line no-console

    if (val !== null) {
      new ResizeObserver(this.onHeaderResize).observe(val);
    }
  }

  @Watch('contentElements')
  onContentElements(val: HTMLCollectionOf<HTMLElement> | null) {
    console.log('Operations: onContentElements()'); // eslint-disable-line no-console

    if (val !== null) {
      // eslint-disable-next-line prefer-destructuring
      this.contentElement = val[0];
    }
  }

  destroyed() {
    console.log('Operations: destroyed()'); // eslint-disable-line no-console

    if (this.tableElement) {
      // tableElement è già il .v-data-table__wrapper
      const wrapper = this.tableElement as HTMLElement;
      wrapper.removeEventListener('scroll', this.onTableScroll);
    }

    this.showUpdateRequired = false;

    if (this.unsubscribeOperationUpdates) this.unsubscribeOperationUpdates();

    this.$store.dispatch('clearOperationsList');
  }

  initHeaders() {
    console.log('Operations: initHeaders()'); // eslint-disable-line no-console

    this.headers.push({
      text: 'Commessa',
      value: 'operation',
      align: 'start',
      sortable: false,
      width: 200,
    });

    this.headers.push({
      text: 'Cliente',
      value: 'customer',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Prov.',
      value: 'province',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Fornitura',
      value: 'supply',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
      width: 150,
    });

    if (this.hasPermission('payments.show')
      || this.hasPermission('payments.edit')
      || this.hasPermission('taskcm.invoiceDiscount.show')
      || this.hasPermission('taskcm.invoiceDiscount.edit')
      || this.hasPermission('taskcm.loan.show')
      || this.hasPermission('taskcm.loan.edit')) {
      this.headers.push({
        text: 'Pagamenti',
        value: 'lastPayment',
        align: 'start',
        class: 'flk-sortable',
        sortable: false,
      });
    }

    this.headers.push({
      text: 'Date commessa',
      value: 'unifiedDates',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: '',
      value: 'children',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'PM e Installatori',
      value: 'installer',
      align: 'start',
      sortable: false,
    });

    if (this.hasPermission('practiceAssignment.show') || this.hasPermission('projectAssignment.show')) {
      this.headers.push({
        text: 'Incarichi',
        value: 'assignments',
        align: 'start',
        sortable: false,
        class: 'flk-sortable',
      });
    }

    this.headers.push({
      text: 'Sopralluogo',
      value: 'siteInspectionDate',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'Titolo autoriz.',
      value: 'plan',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Progetto e c. metrico',
      value: 'plan',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Settimana obiettivo progetto',
      value: 'planDate',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'Pratiche e verifiche',
      value: 'pratices',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Data obiettivo materiale',
      value: 'materialsTargetDate',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'Materiale e spedizione',
      value: 'items',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Sub',
      value: 'sub',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Installazione',
      value: 'installationDate',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'DICO e Visura',
      value: 'dicoDate',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'Documentazione',
      value: 'docs',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Fine lavori',
      value: 'end',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Pronto',
      value: 'readyForFinalPayment',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: 'Commissioning',
      value: 'commissioning',
      align: 'start',
      class: 'flk-sortable',
      sortable: false,
    });

    this.headers.push({
      text: 'Allacciamento e Collaudo CAT',
      value: 'connection',
      align: 'start',
      sortable: false,
      class: 'flk-sortable',
    });

    // this.headers.push({
    //   text: '',
    //   value: 'monitor',
    //   align: 'start',
    //   sortable: false,
    // });

    this.headers.push({
      text: 'Dogane',
      value: 'dogane',
      align: 'start',
      sortable: false,
      width: 150,
    });

    this.headers.push({
      text: 'ENEA/GSE/Altro',
      value: 'eneaPractice',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: '',
      value: 'actions1',
      align: 'start',
      sortable: false,
    });

    this.headers.push({
      text: '',
      value: 'actions2',
      align: 'start',
      sortable: false,
    });
  }

  operationInfo(operation: Operation): OperationInfo {
    return operationInfoFromOperation(operation);
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.user.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  childrenIds(operation: Operation): number[] {
    if (!operation || !operation.childrenIds || operation.childrenIds.length < 3) return [];

    return operation.childrenIds.substring(1, operation.childrenIds.length - 1).split(':')
      .map((s: string) => Number(s))
      // eslint-disable-next-line arrow-body-style
      .filter((childId: number) => {
        return !['closed', 'rejected', 'cancelled'].includes(operation.children[childId].status);
      });
  }

  childStatus(operation: Operation, childId: number): LeadStatus {
    return operation.children[childId].status;
  }

  searchFilterKeyup(event) {
    // Premendo invio i filtri vengono applicati - equivale a premere Applica
    if (event.keyCode === 13) return this.searchFilterUpdated();

    // Backspace, Delete
    if ([8, 46].includes(event.keyCode)) return this.searchFilterNeedsAnUpdate();

    if (String.fromCharCode(event.keyCode).match(/(\w|\s)/g)) {
      return this.searchFilterNeedsAnUpdate();
    }

    return false;
  }

  resetFilters() {
    console.log('Operations: resetFilters()'); // eslint-disable-line no-console

    this.$set(this.filters, 'search', '');
    this.$set(this.filters, 'requester', null);
    this.$set(this.filters, 'owner', []);
    this.$set(this.filters, 'ownerLogic', 'OR');
    this.$set(this.filters, 'ownerNegated', []);
    this.$set(this.filters, 'practiceAssignees', []);
    this.$set(this.filters, 'practiceAssigneesLogic', 'OR');
    this.$set(this.filters, 'practiceAssigneesStatus', null);
    this.$set(this.filters, 'practiceAssigneesNegated', []);
    this.$set(this.filters, 'projectAssignees', []);
    this.$set(this.filters, 'projectAssigneesLogic', 'OR');
    this.$set(this.filters, 'projectAssigneesStatus', null);
    this.$set(this.filters, 'projectAssigneesNegated', []);
    this.$set(this.filters, 'eneaAssignees', []);
    this.$set(this.filters, 'eneaAssigneesLogic', 'OR');
    this.$set(this.filters, 'eneaAssigneesStatus', null);
    this.$set(this.filters, 'eneaAssigneesNegated', []);
    this.$set(this.filters, 'doganeAssignees', []);
    this.$set(this.filters, 'doganeAssigneesLogic', 'OR');
    this.$set(this.filters, 'doganeAssigneesStatus', null);
    this.$set(this.filters, 'doganeAssigneesNegated', []);
    this.$set(this.filters, 'installerAssignees', []);
    this.$set(this.filters, 'installerAssigneesLogic', 'OR');
    this.$set(this.filters, 'installerAssigneesStatus', null);
    this.$set(this.filters, 'installerAssigneesNegated', []);
    this.filtersSyncToken += 1;
    this.$set(this.filters, 'categories', []);
    this.$set(this.filters, 'categoriesLogic', 'AND');
    this.$set(this.filters, 'categoriesNegated', []);
    this.$set(this.filters, 'tags', []);
    this.$set(this.filters, 'tagsLogic', 'AND');
    this.$set(this.filters, 'tagsNegated', []);
    this.$set(this.filters, 'provinces', []);
    this.$set(this.filters, 'provincesLogic', 'AND');
    this.$set(this.filters, 'provincesNegated', []);
    this.$set(this.filters, 'childType', []);
    this.$set(this.filters, 'projectStatus', []);
    this.$set(this.filters, 'warehouse', []);
    this.$set(this.filters, 'shipmentStatus', []);

    this.$set(this.filters, 'partialInstallationStatus', null);
    this.$set(this.filters, 'partialInstallationDateStatus', null);
    this.$set(this.filters, 'installationStatus', null);
    this.$set(this.filters, 'installationDateStatus', null);

    this.$set(this.filters, 'dicoStatus', []);
    this.$set(this.filters, 'missingFinishings', []);

    this.$set(this.filters, 'readyForFinalPayment', null);
    this.$set(this.filters, 'shipmentCompleted', null);
    this.$set(this.filters, 'internetConnection', null);
    this.$set(this.filters, 'serviceConfirm', null);
    this.$set(this.filters, 'inverterConnected', null);
    this.$set(this.filters, 'testingDateConfirm', null);
    this.$set(this.filters, 'docsSentToPartner', null);

    this.$set(this.filters, 'testingOutcome', []);
    this.$set(this.filters, 'egridConnectionStatus', []);
    this.$set(this.filters, 'archivedStatus', []);
    this.$set(this.filters, 'childStatus', []);
    this.$set(this.filters, 'fatherStatus', []);
    this.$set(this.filters, 'taskO', []);
    this.$set(this.filters, 'taskCm', []);
    this.$set(this.filters, 'opType', []);
    this.$set(this.filters, 'payments', []);
    this.$set(this.filters, 'sortBy', []);
    this.$set(this.filters, 'sortDesc', []);
    this.$set(this.filters, 'dates', {
      value: null,
      begin: null,
      end: null,
    });

    this.$set(this.options, 'sortBy', []);
    this.$set(this.options, 'sortDesc', []);

    this.$set(this.filters, 'searchItems', []);
    this.$set(this.filters, 'searchValue', null);
    this.$set(this.filters, 'searchLogic', 'OR');
    this.$set(this.filters, 'searchExclude', null);

    // TODO: reset di tutti i filtri
    this.filtersNeedsAnUpdate();
  }

  async onSavePreset({ name, filters }: { name: string; filters: any }) {
    console.log('Operations: onSavePreset()', { name, filters }); // eslint-disable-line no-console

    try {
      await this.$store.dispatch('saveOperationsFilterPreset', { name, filters });
      console.log(`Preset "${name}" salvato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nel salvataggio del preset:', error); // eslint-disable-line no-console
    }
  }

  async onLoadPreset({ name, filters }: { name: string; filters: any }) {
    console.log('Operations: onLoadPreset()', { name, filters }); // eslint-disable-line no-console

    try {
      // Applica i filtri del preset
      Object.keys(filters).forEach((key: string) => {
        this.$set(this.filters, key, filters[key]);
      });

      // Segnala ai componenti figli (AssignmentFilterToggle) che i filtri
      // sono cambiati programmaticamente: devono ricalcolare il loro stato UI derivato.
      this.filtersSyncToken += 1;

      // Applica i filtri in modo asincrono per non bloccare l'UI
      await this.$nextTick();
      this.filtersUpdated();
      console.log(`Preset "${name}" caricato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nel caricamento del preset:', error); // eslint-disable-line no-console
    }
  }

  async onDeletePreset({ name }: { name: string }) {
    try {
      await this.$store.dispatch('deleteOperationsFilterPreset', name);
      console.log(`Preset "${name}" eliminato con successo`); // eslint-disable-line no-console
    } catch (error) {
      console.error('Errore nell\'eliminazione del preset:', error); // eslint-disable-line no-console
    }
  }

  get areFiltersEmpty() {
    if (this.filters?.search && this.filters.search.trim() !== '') return false;
    if (this.filters?.requester !== null) return false;
    if (this.filters?.owner && Array.isArray(this.filters.owner)
      && this.filters.owner.length > 0) return false;
    if (this.filters?.ownerLogic && this.filters.ownerLogic !== 'OR') return false;
    if (this.filters?.practiceAssignees && Array.isArray(this.filters.practiceAssignees)
      && this.filters.practiceAssignees.length > 0) return false;
    if (this.filters?.practiceAssigneesLogic && this.filters.practiceAssigneesLogic !== 'OR') return false;
    if (this.filters?.practiceAssigneesStatus !== null
      && this.filters?.practiceAssigneesStatus !== undefined) return false;
    if (this.filters?.projectAssignees && Array.isArray(this.filters.projectAssignees)
      && this.filters.projectAssignees.length > 0) return false;
    if (this.filters?.projectAssigneesLogic && this.filters.projectAssigneesLogic !== 'OR') return false;
    if (this.filters?.projectAssigneesStatus !== null
      && this.filters?.projectAssigneesStatus !== undefined) return false;
    if (this.filters?.eneaAssignees && Array.isArray(this.filters.eneaAssignees)
      && this.filters.eneaAssignees.length > 0) return false;
    if (this.filters?.eneaAssigneesLogic && this.filters.eneaAssigneesLogic !== 'OR') return false;
    if (this.filters?.eneaAssigneesStatus !== null
      && this.filters?.eneaAssigneesStatus !== undefined) return false;
    if (this.filters?.doganeAssignees && Array.isArray(this.filters.doganeAssignees)
      && this.filters.doganeAssignees.length > 0) return false;
    if (this.filters?.doganeAssigneesLogic && this.filters.doganeAssigneesLogic !== 'OR') return false;
    if (this.filters?.doganeAssigneesStatus !== null
      && this.filters?.doganeAssigneesStatus !== undefined) return false;
    if (this.filters?.installerAssignees && Array.isArray(this.filters.installerAssignees)
      && this.filters.installerAssignees.length > 0) return false;
    if (this.filters?.installerAssigneesLogic && this.filters.installerAssigneesLogic !== 'OR') return false;
    if (this.filters?.installerAssigneesStatus !== null
      && this.filters?.installerAssigneesStatus !== undefined) return false;
    if (this.filters?.categories && Array.isArray(this.filters.categories)
      && this.filters.categories.length > 0) return false;
    if (this.filters?.categoriesLogic && this.filters.categoriesLogic !== 'AND') return false;
    if (this.filters?.tags && Array.isArray(this.filters.tags)
      && this.filters.tags.length > 0) return false;
    if (this.filters?.tagsLogic && this.filters.tagsLogic !== 'AND') return false;
    if (this.filters?.provinces && Array.isArray(this.filters.provinces)
      && this.filters.provinces.length > 0) return false;
    if (this.filters?.provincesLogic && this.filters.provincesLogic !== 'AND') return false;
    if (this.filters?.childType && Array.isArray(this.filters.childType)
      && this.filters.childType.length > 0) return false;
    if (this.filters?.projectStatus && Array.isArray(this.filters.projectStatus)
      && this.filters.projectStatus.length > 0) return false;
    if (this.filters?.warehouse && Array.isArray(this.filters.warehouse)
      && this.filters.warehouse.length > 0) return false;
    if (this.filters?.shipmentStatus && Array.isArray(this.filters.shipmentStatus)
      && this.filters.shipmentStatus.length > 0) return false;

    if (this.filters?.partialInstallationStatus !== null) return false;
    if (this.filters?.partialInstallationDateStatus !== null) return false;
    if (this.filters?.installationStatus !== null) return false;
    if (this.filters?.installationDateStatus !== null) return false;

    if (this.filters?.dicoStatus && Array.isArray(this.filters.dicoStatus)
      && this.filters.dicoStatus.length > 0) return false;
    if (this.filters?.missingFinishings && Array.isArray(this.filters.missingFinishings)
      && this.filters.missingFinishings.length > 0) return false;

    if (this.filters?.readyForFinalPayment !== null
      && this.filters?.readyForFinalPayment !== undefined) return false;
    if (this.filters?.shipmentCompleted !== null
      && this.filters?.shipmentCompleted !== undefined) return false;
    if (this.filters?.internetConnection !== null
      && this.filters?.internetConnection !== undefined) return false;
    if (this.filters?.serviceConfirm !== null
      && this.filters?.serviceConfirm !== undefined) return false;
    if (this.filters?.inverterConnected !== null
      && this.filters?.inverterConnected !== undefined) return false;
    if (this.filters?.testingDateConfirm !== null
      && this.filters?.testingDateConfirm !== undefined) return false;
    if (this.filters?.docsSentToPartner !== null
      && this.filters?.docsSentToPartner !== undefined) return false;

    if (this.filters?.testingOutcome && Array.isArray(this.filters.testingOutcome)
      && this.filters.testingOutcome.length > 0) return false;
    if (this.filters?.egridConnectionStatus && Array.isArray(this.filters.egridConnectionStatus)
      && this.filters.egridConnectionStatus.length > 0) return false;
    if (this.filters?.archivedStatus && Array.isArray(this.filters.archivedStatus)
      && this.filters.archivedStatus.length > 0) return false;
    if (this.filters?.childStatus && Array.isArray(this.filters.childStatus)
      && this.filters.childStatus.length > 0) return false;
    if (this.filters?.fatherStatus && Array.isArray(this.filters.fatherStatus)
      && this.filters.fatherStatus.length > 0) return false;
    if (this.filters?.taskO && Array.isArray(this.filters.taskO)
      && this.filters.taskO.length > 0) return false;
    if (this.filters?.taskCm && Array.isArray(this.filters.taskCm)
      && this.filters.taskCm.length > 0) return false;
    if (this.filters?.opType && Array.isArray(this.filters.opType)
      && this.filters.opType.length > 0) return false;
    if (this.filters?.payments && Array.isArray(this.filters.payments)
      && this.filters.payments.length > 0) return false;
    if (this.filters?.sortBy && Array.isArray(this.filters.sortBy)
      && this.filters.sortBy.length > 0) return false;
    if (this.filters?.sortDesc && Array.isArray(this.filters.sortDesc)
      && this.filters.sortDesc.length > 0) return false;
    if (this.filters?.dates && this.filters?.dates?.value !== null) return false;

    if (this.filters?.searchItems && Array.isArray(this.filters.searchItems)
      && this.filters.searchItems.length > 0) return false;
    if (this.filters?.searchValue !== null) return false;

    return true;
  }

  filtersNeedsAnUpdate() {
    console.log('Operations: filtersNeedsAnUpdate()'); // eslint-disable-line no-console
    this.applyFiltersDisabled = false;
    this.applyFiltersTimeout = 10;
    this.applyFiltersCount += 1;
  }

  // --- Commissioning tri-state helpers ---

  // Map: field → [positiveValue, negativeValue, neutralTooltip, positiveTooltip, negativeTooltip]
  private readonly COMMISSIONING_FIELD_META: Record<
    'internetConnection' | 'serviceConfirm' | 'inverterConnected',
    [string, string, string, string, string]
  > = {
    internetConnection: [
      'tested',
      'not-tested',
      'Filtra per stato connessione internet',
      'Filtra: connessione internet testata',
      'Filtra: connessione internet non testata',
    ],
    serviceConfirm: [
      'confirmed',
      'not-confirmed',
      'Filtra per stato service SY',
      'Filtra: service SY confermato',
      'Filtra: service SY non confermato',
    ],
    inverterConnected: [
      'connected',
      'not-connected',
      'Filtra per stato portale di monitoraggio',
      'Filtra: portale di monitoraggio connesso',
      'Filtra: portale di monitoraggio non connesso',
    ],
  };

  cycleCommissioningFilter(field: 'internetConnection' | 'serviceConfirm' | 'inverterConnected'): void {
    const [positive, negative] = this.COMMISSIONING_FIELD_META[field];
    const current = (this.filters as unknown as Record<string, string | null>)[field];
    let next: string | null;
    if (current === null || current === undefined) {
      next = positive;
    } else if (current === positive) {
      next = negative;
    } else {
      next = null;
    }
    this.$set(this.filters, field, next);
    this.filtersNeedsAnUpdate();
  }

  commissioningFilterClass(value: string | null): string {
    if (value === 'tested' || value === 'confirmed' || value === 'connected') {
      return 'success--text';
    }
    if (value === 'not-tested' || value === 'not-confirmed' || value === 'not-connected') {
      return 'orange--text';
    }
    return '';
  }

  commissioningFilterTooltip(field: 'internetConnection' | 'serviceConfirm' | 'inverterConnected'): string {
    const [positive, negative, neutral, positiveLabel, negativeLabel] = this.COMMISSIONING_FIELD_META[field];
    const current = (this.filters as unknown as Record<string, string | null>)[field];
    if (current === positive) return positiveLabel;
    if (current === negative) return negativeLabel;
    return neutral;
  }

  // --- Fine Commissioning tri-state helpers ---

  // --- Testing date confirm tri-state helper (single field) ---

  cycleTestingDateConfirm(): void {
    const current = this.filters.testingDateConfirm;
    let next: TestingDateConfirmFilter | null;
    if (current === null || current === undefined) {
      next = 'confirmed';
    } else if (current === 'confirmed') {
      next = 'not-confirmed';
    } else {
      next = null;
    }
    this.$set(this.filters, 'testingDateConfirm', next);
    this.filtersNeedsAnUpdate();
  }

  get testingDateConfirmClass(): string {
    if (this.filters.testingDateConfirm === 'confirmed') return 'success--text';
    if (this.filters.testingDateConfirm === 'not-confirmed') return 'orange--text';
    return '';
  }

  get testingDateConfirmTooltip(): string {
    if (this.filters.testingDateConfirm === 'confirmed') return 'Filtra: data di collaudo confermata';
    if (this.filters.testingDateConfirm === 'not-confirmed') return 'Filtra: data di collaudo non confermata';
    return 'Filtra per stato data di collaudo';
  }

  // --- Fine testing date confirm helper ---

  // --- Docs sent to partner tri-state helper ---

  cycleDocsSentToPartner(): void {
    const current = this.filters.docsSentToPartner;
    let next: DocsSentToPartnerFilter | null;
    if (current === null || current === undefined) {
      next = 'sent';
    } else if (current === 'sent') {
      next = 'not-sent';
    } else {
      next = null;
    }
    this.$set(this.filters, 'docsSentToPartner', next);
    this.filtersNeedsAnUpdate();
  }

  get docsSentToPartnerIcon(): string {
    return this.filters.docsSentToPartner === 'sent'
      ? 'mdi-folder-table'
      : 'mdi-folder-table-outline';
  }

  get docsSentToPartnerIconColor(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'success';
    if (this.filters.docsSentToPartner === 'not-sent') return 'orange';
    return '';
  }

  get docsSentToPartnerClass(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'success--text';
    if (this.filters.docsSentToPartner === 'not-sent') return 'orange--text';
    return '';
  }

  get docsSentToPartnerTooltip(): string {
    if (this.filters.docsSentToPartner === 'sent') return 'Filtra: documentazione fine lavori inviata';
    if (this.filters.docsSentToPartner === 'not-sent') return 'Filtra: documentazione fine lavori NON inviata';
    return 'Filtra per invio documentazione fine lavori';
  }

  // --- Fine docs sent to partner helper ---

  searchFilterNeedsAnUpdate() {
    if (this.filters?.search?.trim() === this.previousSearch?.trim()) return false;
    return this.filtersNeedsAnUpdate();
  }

  get operationsFilterPresets() {
    return this.$store.getters.currentOperationsFilterPresets ?? [];
  }

  filtersUpdated() {
    console.log('Operations: filtersUpdated()'); // eslint-disable-line no-console
    this.applyFiltersDisabled = true;
    this.applyFiltersTimeout = 0;
    this.previousSearch = this.filters.search;
    console.log('Operations: filtersUpdated() this.filters =', this.filters); // eslint-disable-line no-console
    this.$store.dispatch('updateOperationsFilters', this.filters);
    this.reload();
  }

  searchFilterUpdated() {
    if (this.filters?.search?.trim() === this.previousSearch?.trim()) return false;
    return this.filtersUpdated();
  }

  // Ricarica l'elenco commesse
  async reload() {
    console.log('Operations: reload()'); // eslint-disable-line no-console

    this.showUpdateRequired = false;

    // Elimina l'elenco commesse attuale attuale
    this.$store.dispatch('clearOperationsList');

    await this.onGetOperations();

    // Sincronizza le altezze delle celle multiple dopo il rendering
    await this.$nextTick();

    // Avvia l'aggiornamento del contatore
    setTimeout(() => {
      this.$store.dispatch('getOperationsCount');
    }, 2000);
  }

  // Sincronizza l'altezza di tutte le status-cell-line della stessa figlia
  // (solo quelle della commessa onlyOperationId, se specificata)
  syncCellLineHeights(onlyOperationId?: number) {
    console.log('Operations: syncCellLineHeights()', onlyOperationId ?? ''); // eslint-disable-line no-console

    // Limita la ricerca al contenitore della tabella invece dell'intero documento
    const container = this.$refs.operationsContainer as HTMLElement | undefined;
    if (!container) {
      return;
    }

    // Raggruppa tutte le status-cell-line per operation-id e child-id
    const cellLinesByChild = new Map<string, HTMLElement[]>();

    // Trova tutte le status-cell-line e actions-cell-line nel contenitore
    const selector = onlyOperationId === undefined
      ? '.status-cell-line, .actions-cell-line'
      : `.status-cell-line[data-operation-id="${onlyOperationId}"], .actions-cell-line[data-operation-id="${onlyOperationId}"]`;
    const allCellLines = container.querySelectorAll(selector) as NodeListOf<HTMLElement>;

    allCellLines.forEach((cellLine) => {
      const operationId = cellLine.getAttribute('data-operation-id');
      const childId = cellLine.getAttribute('data-child-id');

      if (operationId && childId) {
        const key = `${operationId}-${childId}`;
        if (!cellLinesByChild.has(key)) {
          cellLinesByChild.set(key, []);
        }
        cellLinesByChild.get(key)!.push(cellLine);
      }
    });

    // Per ogni gruppo, calcola l'altezza massima e applicala a tutte
    cellLinesByChild.forEach((cellLines) => {
      // Prima fase: resetta tutte le altezze a 'auto' (batch write)
      for (let i = 0; i < cellLines.length; i += 1) {
        // eslint-disable-next-line no-param-reassign
        cellLines[i].style.height = 'auto';
      }

      // Seconda fase: leggi tutte le altezze (batch read)
      const heights: number[] = [];
      for (let i = 0; i < cellLines.length; i += 1) {
        const height = cellLines[i].offsetHeight;
        heights.push(height);
      }

      // Calcola l'altezza massima
      const maxHeight = heights.length > 0 ? Math.max(...heights) : 0;

      // Terza fase: applica l'altezza massima a tutte le celle del gruppo (batch write)
      if (maxHeight > 0) {
        for (let i = 0; i < cellLines.length; i += 1) {
          // eslint-disable-next-line no-param-reassign
          cellLines[i].style.height = `${maxHeight}px`;
        }
      }
    });
  }

  phNeeded(operation: Operation, childId: number): boolean {
    const typeFilter: LeadType[] = this.currentFilters?.childType;

    // Se è attivo un filtro sulla tipologia di lavorazione
    // ed è 'elettrica-figlia' o 'termica-figlia'...
    if (
      (typeFilter.includes('elettrica-figlia') && !typeFilter.includes('termica-figlia'))
      || (!typeFilter.includes('elettrica-figlia') && typeFilter.includes('termica-figlia'))
    ) {
      // ... mostra sempre e comunque i controlli
      return false;
    }

    // Non è attivo nessun filtro sul tipo oppure sono filtrate ma mostrate
    // sia le lavorazioni termiche che elettriche.

    // Se il progetto in questione ha entrambe le lavorazioni...
    let hasT = false;
    let hasE = false;
    Object.values(operation.children)
      .forEach((child) => {
        if (child.type === 'elettrica-figlia') {
          hasE = true;
        } else if (child.type === 'termica-figlia') {
          hasT = true;
        }
      });

    return hasT && hasE
      && operation.children[childId].type === 'termica-figlia';
  }

  childTypeIs(item: Operation, childId: number, type: string | string[]): boolean {
    const types = Array.isArray(type) ? type : [type];

    return item
      && 'children' in item
      && item.children
      && childId in item.children
      && item.children[childId]
      && types.includes(item.children[childId].type);
  }

  onEditTask(name: string, childId: number, fatherId: number | null = null, focusField: string | null = null) {
    console.log(`Operations: onEditTask(${name}, ${childId}, ${fatherId}, focusField=${focusField})`); // eslint-disable-line no-console

    // Seleziona il Task (e la Lead a cui appartiene)
    // Se specificato un id del padre, recupera anche quello se necessario.
    // `focusField`, se valorizzato, indica a EditTaskDialog quale blocco scrollare
    // automaticamente in vista dopo il caricamento del Task.
    this.$store.dispatch('selectTask', {
      name, leadId: childId, fatherId, focusField,
    });

    // Non attende e apre subito il dialog
    this.editTaskDialog = true;
  }

  onEditPayments(projectId) {
    console.log('Operations: onEditPayments()'); // eslint-disable-line no-console
    this.selectedProjectId = projectId;
    this.editPaymentsDialog = true;
  }

  onEditChildUsers(childProjectId) {
    console.log(`Operations: onEditChildUsers() childProjectId = ${childProjectId}`); // eslint-disable-line no-console
    this.selectedChildProjectId = childProjectId;
    this.editChildUsersDialog = true;
  }

  onDownloadAllAttachments(itemId) {
    this.downloading = true;
    window.location.href = `/operation/attachments/${itemId}/all`;
    setTimeout(() => {
      this.downloading = false;
    }, 2000);
  }

  onArchiveOperation(itemId) {
    this.selectedProjectId = itemId;
    this.archiveOperationDialog = true;
  }

  onPauseCountdown() {
    console.log('Operations: onPauseCountdown()'); // eslint-disable-line no-console

    this.applyFiltersDisabled = true;
    this.applyFiltersTimeout = 0;
  }

  onSort(name: string) {
    console.log(`Operations: onSort('${name}')`); // eslint-disable-line no-console

    const index = this.options.sortBy?.findIndex((n) => n === name);

    if (index !== null && index !== undefined && index > -1) {
      // È già attivo un ordinamento su questa colonna
      console.log(`Operations: onSort('${name}') ordinamento già attivo`); // eslint-disable-line no-console

      if (this.options.sortDesc
        && index in this.options.sortDesc
        && (this.options.sortDesc[index] === false || this.options.sortDesc[index] === 'false')) {
        // Inverte l'ordinamento
        console.log(`Operations: onSort('${name}') inverto l'ordinamento`); // eslint-disable-line no-console
        this.$set(this.options, 'sortDesc', [true]);
      } else {
        // Disattiva l'ordinamento
        console.log(`Operations: onSort('${name}') disattivo l'ordinamento`); // eslint-disable-line no-console
        this.$set(this.options, 'sortBy', []);
        this.$set(this.options, 'sortDesc', []);
      }
    } else {
      console.log(`Operations: onSort('${name}') nessun ordinamento attivo`); // eslint-disable-line no-console
      console.log(`Operations: onSort('${name}') attivo l'ordinamento`); // eslint-disable-line no-console
      this.$set(this.options, 'sortBy', [name]);
      this.$set(this.options, 'sortDesc', [false]);
    }

    this.onOptionsChange();
  }

  onFilter(name: string, begin: Date | null | false, end: Date | null | false) {
    console.log(`Operations: onFilter('${name}', %o, %o)`, begin, end); // eslint-disable-line no-console

    if (begin) {
      // Filtra per un intervallo di date
      this.$set(this.filters, 'dates', {
        value: name,
        begin,
        end: end ?? begin,
      });
    } else {
      this.$set(this.filters, 'dates', {
        value: begin === false && end === false ? name : null,
        begin,
        end,
      });
    }

    this.filtersNeedsAnUpdate();
  }

  onSearch(payload: { items: string[]; value: string | null; logic?: 'AND' | 'OR' | null; exclude?: string | null }) {
    console.log('Operations: onSearch()', payload); // eslint-disable-line no-console

    this.$set(this.filters, 'searchItems', payload.items);
    this.$set(this.filters, 'searchValue', payload.value);
    this.$set(this.filters, 'searchLogic', payload.logic === 'AND' ? 'AND' : 'OR');
    this.$set(this.filters, 'searchExclude', payload.exclude ?? null);

    this.filtersNeedsAnUpdate();
  }

  onCategoryFilterUpdate(items: number[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log('Operations: onCategoryFilterUpdate()'); // eslint-disable-line no-console

    console.log('Operations: onCategoryFilterUpdate() items =', items); // eslint-disable-line no-console
    console.log('Operations: onCategoryFilterUpdate() logic =', logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'categories',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'categoriesLogic',
        logic || 'AND',
      );
    }

    this.$set(this.filters, 'categoriesNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onTagFilterUpdate(items: number[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log('Operations: onTagFilterUpdate()'); // eslint-disable-line no-console

    console.log('Operations: onTagFilterUpdate() items =', items); // eslint-disable-line no-console
    console.log('Operations: onTagFilterUpdate() logic =', logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'tags',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'tagsLogic',
        logic || 'AND',
      );
    }

    this.$set(this.filters, 'tagsNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onProvinceFilterUpdate(items: string[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log('Operations: onProvinceFilterUpdate()'); // eslint-disable-line no-console

    console.log('Operations: onProvinceFilterUpdate() items =', items); // eslint-disable-line no-console
    console.log('Operations: onProvinceFilterUpdate() logic =', logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'provinces',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'provincesLogic',
        logic || 'AND',
      );
    }

    this.$set(this.filters, 'provincesNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onOwnerFilterUpdate(items: number[], logic: LogicType, negatedIds?: (number | string)[]) {
    console.log('Operations: onOwnerFilterUpdate()'); // eslint-disable-line no-console

    console.log('Operations: onOwnerFilterUpdate() items =', items); // eslint-disable-line no-console
    console.log('Operations: onOwnerFilterUpdate() logic =', logic); // eslint-disable-line no-console

    if (items) {
      this.$set(
        this.filters,
        'owner',
        Array.isArray(items)
          ? items
          : [],
      );
    }

    if (logic) {
      this.$set(
        this.filters,
        'ownerLogic',
        logic || 'OR',
      );
    }

    this.$set(this.filters, 'ownerNegated', negatedIds ?? []);

    this.filtersNeedsAnUpdate();
  }

  onAssignmentFilterUpdate(typeId: string, data: { assignees: (number | null)[]; logic: LogicType; negated: (number | string)[] }) {
    console.log('Operations: onAssignmentFilterUpdate() typeId =', typeId); // eslint-disable-line no-console
    console.log('Operations: onAssignmentFilterUpdate() data =', data); // eslint-disable-line no-console

    if (data.assignees) {
      this.$set(
        this.filters,
        `${typeId}Assignees`,
        Array.isArray(data.assignees) ? data.assignees : [],
      );
    }

    if (data.logic) {
      this.$set(
        this.filters,
        `${typeId}AssigneesLogic`,
        data.logic || 'OR',
      );
    }

    this.$set(this.filters, `${typeId}AssigneesNegated`, data.negated ?? []);
  }

  onAssignmentStatusChange(typeId: string, status: PracticeAssigneesStatus | null) {
    console.log('Operations: onAssignmentStatusChange() typeId =', typeId); // eslint-disable-line no-console
    console.log('Operations: onAssignmentStatusChange() status =', status); // eslint-disable-line no-console

    this.$set(this.filters, `${typeId}AssigneesStatus`, status);
  }

  async onExport() {
    console.log('Operations: onExport()'); // eslint-disable-line no-console

    await this.$store.dispatch('exportOperations');
  }

  async onExportArchivables() {
    console.log('Operations: onExportArchivables()'); // eslint-disable-line no-console

    await this.$store.dispatch('exportArchivables');
  }

  async onExportTimestamps() {
    console.log('Operations: onExportTimestamps()'); // eslint-disable-line no-console
    await this.$store.dispatch('exportTimestamps');
  }

  async onGetOperations() {
    console.log('Operations: onGetOperations()'); // eslint-disable-line no-console

    let doItAgain = true;

    while (doItAgain) {
      console.log('Operations: onGetOperations() richiamo getOperations'); // eslint-disable-line no-console

      // eslint-disable-next-line no-await-in-loop
      this.more = await this.$store.dispatch('getOperations');

      // Sincronizza le altezze dopo ogni caricamento
      // eslint-disable-next-line no-await-in-loop
      await this.$nextTick();
      this.syncCellLineHeights();

      // Se non ci sono altri risultati da recuperare, si ferma subito
      if (!this.more) break;

      const scrollHeight = this.tableElement?.scrollHeight ?? 0;
      const clientHeight = this.tableElement?.clientHeight ?? 0;
      const scrollTop = this.tableElement?.scrollTop ?? 0;
      const distance = scrollHeight - clientHeight - scrollTop;

      console.log('Operations: onGetOperations() scrollHeight =', scrollHeight); // eslint-disable-line no-console
      console.log('Operations: onGetOperations() clientHeight =', clientHeight); // eslint-disable-line no-console
      console.log('Operations: onGetOperations() scrollTop =', scrollTop); // eslint-disable-line no-console
      console.log('Operations: onGetOperations() distance =', distance); // eslint-disable-line no-console

      doItAgain = distance === 0 && scrollHeight === clientHeight;
    }

    return Promise.resolve();
  }

  async onScroll() {
    // Se sta recuperando altri risultati, non fa nulla.
    if (this.updating) return;

    // Se non ci sono altri risultati da recuperare, non fa nulla.
    if (!this.more) return;

    // Calcola la distanza dalla fine della tabella coi risultati
    const scrollHeight = this.tableElement?.scrollHeight ?? 0;
    const clientHeight = this.tableElement?.clientHeight ?? 0;
    const scrollTop = this.tableElement?.scrollTop ?? 0;
    const distance = scrollHeight - clientHeight - scrollTop;

    if (distance < 200) {
      console.log('Operations: onScroll() richiamo getOperations'); // eslint-disable-line no-console
      this.more = await this.$store.dispatch('getOperations');
      // Sincronizza le altezze dopo il caricamento
      await this.$nextTick();
      this.syncCellLineHeights();
    }
  }

  onHorizontalScroll() {
    if (!this.tableElement) {
      return;
    }

    // tableElement è già il .v-data-table__wrapper
    const wrapper = this.tableElement as HTMLElement;
    const scrollLeft = wrapper.scrollLeft ?? 0;
    const hasScroll = scrollLeft > 0;

    if (hasScroll !== this.hasHorizontalScroll) {
      this.$set(this, 'hasHorizontalScroll', hasScroll);
    }
  }

  onHeaderResize() {
    if (this.contentElement) this.contentElement.style.top = this.headerElement ? `${this.headerElement.offsetHeight}px` : '125px';
  }

  get hasDateFilters(): boolean {
    return (Array.isArray(this.filters.sortBy) && this.filters.sortBy.length > 0)
      || this.filters.dates.value !== null;
  }

  onResetDateFilters() {
    console.log('Operations: onResetDateFilters()'); // eslint-disable-line no-console

    this.$set(
      this.filters,
      'sortBy',
      [],
    );

    this.$set(
      this.options,
      'sortBy',
      [],
    );

    this.$set(
      this.filters,
      'sortDesc',
      [],
    );

    this.$set(
      this.options,
      'sortDesc',
      [],
    );

    this.$set(this.filters, 'dates', {
      value: null,
      begin: null,
      end: null,
    });

    this.filtersNeedsAnUpdate();
  }
}
